import { initializeApp } from 'firebase/app';

import { getMessaging } from 'firebase/messaging';

// Firebase Config values imported from .env file
const firebaseConfig = {
  apiKey: 'AIzaSyAvFLrwQiz9Uf8XiQRmyVGVQeouembsrj8',
  authDomain: 'decent-craft-256200.firebaseapp.com',
  projectId: 'decent-craft-256200',
  storageBucket: 'decent-craft-256200.appspot.com',
  messagingSenderId: '985888935258',
  appId: '1:985888935258:web:75684f7417d2ce2c0e3763',
  measurementId: 'G-YK6FW45N7D',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Messaging service
export default getMessaging(app);
